/**
 * CRA entry point. Mounts the Redux store + React Router + MUI theme,
 * then renders the route table.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

import App from './App';
import { store } from './app/store';
import { UI_CONFIG } from './utils/constants';

import './index.css';
import './App.css';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: UI_CONFIG.PRIMARY_COLOR },
    error: { main: UI_CONFIG.ERROR_COLOR },
    // MUI dark mode defaults `background.default` to #121212, which CssBaseline
    // injects as `body { background-color }` *after* index.css and overrides the
    // F&P black. Pin it to #000 so the body background mirrors the old app.
    background: { default: '#000' },
  },
  typography: {
    fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found in index.html');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
